import { render } from "./salesContract.vue?vue&type=template&id=3aa479a5&ts=true"
import script from "./salesContract.vue?vue&type=script&lang=ts"
export * from "./salesContract.vue?vue&type=script&lang=ts"

import "./salesContract.vue?vue&type=style&index=0&id=3aa479a5&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__